import React, { useCallback } from 'react';

import {
  Slide, Grid, IconButton, Box,
} from '@mui/material';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { useRedirect, useNotify, useRefresh } from 'react-admin';

import PingCreate from '../../ping/PingCreate';
import errorNotification from '../../../utilities/errorNotification';

const AddPing = ({ id }: {id: string}) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();

  const onSuccess = useCallback(() => {
    redirect(`/cases/${id}`);
    refresh();
    notify('New ping attached to case', { type: 'success' });
  }, [id, notify, redirect, refresh]);

  const onError = useCallback((e: Error) => {
    notify(errorNotification(e), { type: 'error' });
  }, [notify]);

  return (
    <Slide in direction="right">
      <Grid container spacing={2} p={2}>
        <Grid size={12}>
          <IconButton onClick={() => redirect(`/cases/${id}`)}>
            <ArrowBackIosIcon fontSize="medium" color="primary" />
          </IconButton>
        </Grid>
        <Grid size={12}>
          <Box bgcolor="white" boxShadow="rgba(50, 50, 93, 0.025) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px">
            <PingCreate caseId={id} resource="pings" onError={onError} onSuccess={onSuccess} />
          </Box>
        </Grid>
      </Grid>
    </Slide>
  );
};

export default AddPing;
